
// components/ArborDrawer/BenchmarkSection.js
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import IconButton from "@mui/material/IconButton";
import Image from "next/image";
import SquareFootIcon from "@/assets/square-foot.svg";

const BenchmarkSection = ({ onNavigate }) => {
  return (
    <ListItemButton
      sx={{
        minHeight: 48,
        px: 2,
      }}
      onClick={onNavigate}
    >
      <ListItemIcon
        sx={{
          minWidth: 0,
          justifyContent: "center",
          color: "white",
        }}
      >
        <IconButton>
          <Image
            src={SquareFootIcon}
            alt="benchmark"
            width={20}
            height={20}
          />
        </IconButton>
      </ListItemIcon>
      <ListItemText
        primaryTypographyProps={{
          fontWeight: "medium",
          variant: "body1",
          pl: 2,
        }}
        primary={"Benchmarks"}
        sx={{ color: "white" }}
      />
    </ListItemButton>
  );
};

export default BenchmarkSection;